import React from "react";

import { WorkerIcon } from "@packages/ds";
import { useIntl } from "react-intl";

import ServiceIcon from "Components/ServiceIcon";
import { Tooltip } from "ds/Tooltip";

import * as S from "./Service.styles";

const ServiceTitle = ({ service }) => {
  const intl = useIntl();

  return service.kind === "worker" ? (
    <S.Title>
      <ServiceIcon service={service} alt={`${service.name}-icon`} />
      <S.ServiceName>{service.app}</S.ServiceName>
      <S.ServiceName>{" / "}</S.ServiceName>
      <S.WorkerSubtitle>
        <S.WorkerBadge>
          <Tooltip
            tooltip={intl.formatMessage({
              id: "services.metrics.worker"
            })}
            analyticId="metrics.deployment.toggle"
          >
            <WorkerIcon />
          </Tooltip>
        </S.WorkerBadge>
        {service.name.replace(`${service.app}--`, "")}
      </S.WorkerSubtitle>
    </S.Title>
  ) : (
    <S.Title>
      <ServiceIcon service={service} alt={`${service.name}-icon`} />
      {service.name}
    </S.Title>
  );
};

export default ServiceTitle;
